'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { useTheme as _ } from "../Provider/index.js";
import r from "../../external/classnames/index.js";
import F from "../AdvancedAccordion/index.js";
import { useState as s, useCallback as U, useEffect as S } from "react";
import d from "../Form/InputBox.js";
import { FontAwesomeIcon as X } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faFire as K } from "../../external/@fortawesome/pro-light-svg-icons/index.js";
const Q = () => {
  const { isMosh: a, isMoshy: n } = _(), [o, M] = s(""), [m, I] = s(""), [i, w] = s(""), [x, A] = s(""), [c, E] = s(""), [h, B] = s(""), [u, C] = s(""), k = 18, H = 100, R = 100, T = 250, $ = 30, G = 300, b = "Kg", y = "cm", N = "years old", W = U(() => {
    if (!h && !m && !x && c && o && i && u) {
      const t = 10 * parseInt(i) + 6.25 * parseInt(o) - 5 * parseInt(c);
      return (u === "Male" ? t + 5 : t - 161).toFixed();
    }
    return 0;
  }, [c, o, i, u, h, m, x]), Y = [
    {
      title: "What is BMR?",
      isTitleBolded: !0,
      content: "Basal Metabolic Rate (BMR) is the number of calories your body needs to perform basic functions like breathing, circulation, and cell production while at rest. It represents the minimum energy your body requires to maintain vital functions without any physical activity. Your BMR is influenced by factors such as age, gender, weight, and genetics."
    }
  ], f = (t, g, j, l, v) => {
    const p = Number(t);
    return t ? isNaN(p) ? `Invalid ${l}` : p < g ? `${l.charAt(0).toUpperCase() + l.slice(1)} must be at least ${g} ${v}` : p > j ? `${l.charAt(0).toUpperCase() + l.slice(1)} cannot exceed ${j} ${v}` : "" : "";
  };
  return S(() => {
    const t = setTimeout(() => {
      B(f(c, k, H, "age", N)), I(
        f(
          o,
          R,
          T,
          "height",
          y
        )
      ), A(
        f(
          i,
          $,
          G,
          "weight",
          b
        )
      );
    }, 500);
    return () => {
      clearTimeout(t);
    };
  }, [c, o, i]), /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ e.jsx(
      "h2",
      {
        className: r("text-center", {
          "text-green-dark": a,
          "text-black": n
        }),
        children: "Calculate your BMR"
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "mx-auto space-y-4", children: [
      /* @__PURE__ */ e.jsxs("p", { className: r("text-center text-grey-400 pb-4"), children: [
        "Knowing your Basal Metabolic Rate (BMR) helps determine any health risks you may face if ",
        /* @__PURE__ */ e.jsx("br", {}),
        "you’re outside of the healthy range."
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "max-w-[500px] mx-auto space-y-4", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col md:grid md:grid-cols-2 gap-4", children: [
          /* @__PURE__ */ e.jsx(
            d,
            {
              heading: "Your Age",
              unit: N,
              variant: "number",
              value: c,
              onChange: (t) => E(t),
              className: "focus:border-b focus:outline-none text-center",
              error: h
            }
          ),
          /* @__PURE__ */ e.jsx(
            d,
            {
              heading: "Your sex at birth",
              variant: "dropdown",
              options: [
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" }
              ],
              value: u,
              onChange: (t) => C(t),
              placeholder: "Select...",
              className: "text-center"
            }
          ),
          /* @__PURE__ */ e.jsx(
            d,
            {
              heading: "Your Height",
              unit: y,
              variant: "number",
              value: o,
              onChange: (t) => M(t),
              className: "focus:border-b focus:outline-none text-center",
              error: m
            }
          ),
          /* @__PURE__ */ e.jsx(
            d,
            {
              heading: "Your Weight",
              unit: b,
              variant: "number",
              value: i,
              onChange: (t) => w(t),
              className: "focus:border-b focus:outline-none text-center",
              error: x
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: r(
              "flex flex-row justify-between items-center border rounded-2xl p-6 gap-4 text-grey-400",
              { "border-green": a, "border-blue": n }
            ),
            children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col justify-between", children: [
                /* @__PURE__ */ e.jsx(
                  "p",
                  {
                    className: r("text-left", {
                      "text-green-dark": a,
                      "text-black": n
                    }),
                    children: "Your BMR"
                  }
                ),
                /* @__PURE__ */ e.jsxs("div", { className: "flex items-center space-x-1", children: [
                  /* @__PURE__ */ e.jsx(
                    "h3",
                    {
                      className: r("!font-body", {
                        "text-green-faint-dark": a,
                        "text-blue": n
                      }),
                      children: W()
                    }
                  ),
                  /* @__PURE__ */ e.jsx(
                    "p",
                    {
                      className: r(
                        "font-demi text-left",
                        {
                          "text-green-faint-dark": a,
                          "text-blue": n
                        }
                      ),
                      children: "calories per day"
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ e.jsx(
                X,
                {
                  icon: K,
                  size: "2x",
                  className: r({
                    "text-green-faint-light": a,
                    "text-blue": n
                  })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "text-grey-400 text-left", children: "Please always refer to your dietitian for more individualised information including meal plans and advice" }),
        /* @__PURE__ */ e.jsx(F, { items: Y })
      ] })
    ] })
  ] });
};
export {
  Q as default
};
